var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFolder32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.25H5C4.0335 8.25 3.25 9.0335 3.25 10V26C3.25 26.9665 4.0335 27.75 5 27.75H23.2788C24.032 27.75 24.7007 27.268 24.9389 26.5535L28.7115 15.2372L28.737 15.14C28.8245 14.6869 28.4778 14.25 28 14.25H25.75V11L25.7432 10.8982C25.6935 10.5322 25.3797 10.25 25 10.25H12.311L10.5303 8.46967C10.3897 8.32902 10.1989 8.25 10 8.25ZM24.25 14.25V11.75H12C11.8409 11.75 11.687 11.6994 11.5597 11.6072L11.4697 11.5303L9.689 9.75H5C4.86193 9.75 4.75 9.86193 4.75 10V22.3783L7.06056 15.4466C7.28288 14.7796 7.88025 14.3153 8.57134 14.2564L8.72076 14.25H24.25ZM5.04057 26.25H23.2788C23.3864 26.25 23.4819 26.1811 23.5159 26.0791L26.959 15.75H8.72076C8.63467 15.75 8.55631 15.7941 8.51099 15.864L8.48359 15.9209L5.04057 26.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder32);
export default __webpack_public_path__ + "static/media/icon-folder-32.d0399bee.svg";
export { ForwardRef as ReactComponent };